import { render, staticRenderFns } from "./AppMinusIcon.vue?vue&type=template&id=59486c73&"
import script from "./AppMinusIcon.vue?vue&type=script&lang=js&"
export * from "./AppMinusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports